/* eslint-disable react/no-unescaped-entities */

import { FC } from "react";

import { LegalDocumentVariables } from "../../types";

export const hu: FC<LegalDocumentVariables> = ({
  lastUpdated,
  company,
  site,
  email,
  address,
  city,
  country,
  province,
  postalCode,
}) => {
  return (
    <>
      <div>
        <h1>COOKIE SZABÁLYZAT</h1>
        <p>
          <strong>Utolsó frissítés: {lastUpdated}</strong>
        </p>
        <p>
          Ez a Cookie szabályzat elmagyarázza, hogy a(z) {company} („
          <strong>Vállalat</strong>”, „<strong>mi</strong>”, „
          <strong>minket</strong>” és „<strong>miénk</strong>”) hogyan használ
          cookie-kat és hasonló technológiákat annak érdekében, hogy felismerjük
          Önt, amikor meglátogatja a <a href={site}>{site}</a> („
          <strong>Weboldal</strong>”) weboldalunkat. Leírja, hogy mik ezek a
          technológiák, miért használjuk őket, és milyen jogai vannak azok
          használatának ellenőrzésére.
        </p>
        <p>
          Bizonyos esetekben cookie-kat használhatunk személyes adatok
          gyűjtésére, vagy amelyek személyes adatokká válnak, ha más adatokkal
          kombináljuk őket.
        </p>
        <h2>Mik azok a cookie-k?</h2>
        <p>
          A cookie-k kis adatfájlok, amelyeket az Ön számítógépén vagy
          mobileszközén helyezünk el, amikor meglátogat egy weboldalt. A
          cookie-kat széles körben használják a weboldalak tulajdonosai annak
          érdekében, hogy weboldalaik működjenek, hatékonyabban működjenek,
          valamint jelentési információk nyújtására.
        </p>
        <p>
          A weboldal tulajdonosa (jelen esetben {company}) által beállított
          cookie-kat „elsődleges cookie-knak” nevezzük. Más felek által
          beállított cookie-kat „harmadik fél cookie-knak” nevezzük. A harmadik
          fél cookie-k lehetővé teszik, hogy harmadik fél funkciók vagy
          szolgáltatások jelenjenek meg a weboldalon keresztül (például
          reklámok, interaktív tartalmak és elemzések). Az ezeket beállító felek
          felismerhetik az Ön számítógépét mind ezen a weboldalon, mind bizonyos
          más weboldalakon történő látogatáskor.
        </p>
        <h2>Miért használunk cookie-kat?</h2>
        <p>
          Elsődleges és harmadik fél cookie-kat több okból is használunk. Egyes
          cookie-k technikai okokból szükségesek a weboldalunk működéséhez
          („elengedhetetlen” vagy „szigorúan szükséges” cookie-k). Más cookie-k
          lehetővé teszik, hogy nyomon kövessük és célzottan reagáljunk
          felhasználóink érdeklődési körére, javítva online tulajdonaink
          élményét. Harmadik felek cookie-kat szolgáltatnak weboldalunkon
          reklámozás, elemzés és más célokból. Ezek részletesen lentebb kerülnek
          ismertetésre.
        </p>
        <h2>Hogyan ellenőrizhetem a cookie-kat?</h2>
        <p>
          Ön jogosult eldönteni, hogy elfogadja vagy elutasítja a cookie-kat.
          Cookie jogait a Cookie hozzájárulás-kezelőben állíthatja be, amely
          lehetővé teszi, hogy kiválassza, mely kategóriájú cookie-kat fogadja
          el vagy utasítja el. Az alapvető cookie-kat nem lehet elutasítani,
          mivel ezek szigorúan szükségesek a szolgáltatások biztosításához.
        </p>
        <p>
          A Cookie hozzájárulás-kezelőt a weboldalon található értesítő sávban
          találhatja meg. Ha elutasítja a cookie-kat, továbbra is használhatja a
          weboldalt, de bizonyos funkciók és területek korlátozottak lehetnek.
          Böngészőjében is beállíthatja a cookie-k elfogadását vagy
          elutasítását.
        </p>
        <p>
          Weboldalunkon használt elsődleges és harmadik fél cookie-k konkrét
          típusai és céljai az alábbi táblázatban vannak részletezve (vegye
          figyelembe, hogy a konkrét cookie-k a meglátogatott online
          tulajdonoktól függően változhatnak):
        </p>
        <h4>
          <u>Elengedhetetlen weboldal cookie-k:</u>
        </h4>
        <p>
          Ezek a cookie-k nélkülözhetetlenek a weboldalunkon elérhető
          szolgáltatások nyújtásához és bizonyos funkciók használatához, például
          biztonságos területekre való belépéshez.
        </p>
        <table>
          <tbody>
            <tr>
              <td>Név:</td>
              <td>rc::a</td>
            </tr>
            <tr>
              <td>Cél:</td>
              <td>
                A felhasználói viselkedés nyomon követése és elemzése emberek és
                botok, valamint automatizált szoftverek megkülönböztetéséhez.
              </td>
            </tr>
            <tr>
              <td>Szolgáltató:</td>
              <td>www.google.com</td>
            </tr>
            <tr>
              <td>Szolgáltatás:</td>
              <td>
                reCAPTCHA{" "}
                <a href="https://business.safety.google/privacy/">
                  Adatvédelmi szabályzat megtekintése
                </a>
              </td>
            </tr>
            <tr>
              <td>Típus:</td>
              <td>html_local_storage</td>
            </tr>
            <tr>
              <td>Lejárat:</td>
              <td>állandó</td>
            </tr>
          </tbody>
        </table>
        <h4>
          <u>Nem besorolt cookie-k:</u>
        </h4>
        <p>
          Ezek olyan cookie-k, amelyeket még nem kategorizáltunk. Ezeket
          jelenleg kategorizáljuk a szolgáltatóik segítségével.
        </p>
        <table>
          <tbody>
            <tr>
              <td>Név:</td>
              <td>sentryReplaySession</td>
            </tr>
            <tr>
              <td>Szolgáltató:</td>
              <td>{company}</td>
            </tr>
            <tr>
              <td>Típus:</td>
              <td>html_session_storage</td>
            </tr>
            <tr>
              <td>Lejárat:</td>
              <td>munkamenet</td>
            </tr>
          </tbody>
        </table>
        <h2>Hogyan ellenőrizhetem a cookie-kat a böngészőmben?</h2>
        <p>
          A cookie-k böngészője segítségével történő elutasításának módja
          böngészőnként eltérő lehet, ezért kérjük, tekintse meg böngészője
          súgóját további információkért. Az alábbiakban található információ a
          cookie-k kezeléséről a legnépszerűbb böngészőkben:
        </p>
        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95647#zippy=%2Callow-or-block-cookies">
              Chrome
            </a>
          </li>
          <li>
            <a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d">
              Internet Explorer
            </a>
          </li>
          <li>
            <a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&amp;redirectlocale=en-US">
              Firefox
            </a>
          </li>
          <li>
            <a href="https://support.apple.com/en-ie/guide/safari/sfri11471/mac">
              Safari
            </a>
          </li>
          <li>
            <a href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd">
              Edge
            </a>
          </li>
          <li>
            <a href="https://help.opera.com/en/latest/web-preferences/">
              Opera
            </a>
          </li>
        </ul>
        <p>
          Ezen túlmenően a legtöbb hirdetési hálózat lehetőséget biztosít Önnek
          arra, hogy leiratkozzon a célzott hirdetésekről. További
          információkért látogasson el a következő oldalakra:
        </p>
        <ul>
          <li>
            <a href="http://www.aboutads.info/choices/">
              Digital Advertising Alliance
            </a>
          </li>
          <li>
            <a href="https://youradchoices.ca/">
              Digital Advertising Alliance of Canada
            </a>
          </li>
          <li>
            <a href="http://www.youronlinechoices.com/">
              European Interactive Digital Advertising Alliance
            </a>
          </li>
        </ul>

        <h2>
          Mi a helyzet más nyomkövető technológiákkal, például webjelzőkkel?
        </h2>
        <p>
          A cookie-k nem az egyetlen módja annak, hogy felismerjük vagy nyomon
          kövessük a weboldal látogatóit. Időről időre más, hasonló
          technológiákat is használhatunk, mint például a webjelzők („tracking
          pixelek” vagy „clear gif-ek”). Ezek apró grafikai fájlok, amelyek
          egyedi azonosítót tartalmaznak, lehetővé téve számunkra, hogy
          felismerjük, ha valaki meglátogatta weboldalunkat vagy megnyitotta az
          e-maileket, amelyek tartalmazzák ezeket. Így például nyomon
          követhetjük a felhasználók mozgását egyik oldalról a másikra,
          cookie-kat közvetíthetünk vagy kommunikálhatunk velük,
          ellenőrizhetjük, hogy harmadik fél weboldalán megjelenő hirdetésből
          érkezett-e hozzánk, javíthatjuk az oldal teljesítményét és mérhetjük
          e-mail marketing kampányaink sikerességét. Sok esetben ezek a
          technológiák cookie-któl függnek, így azok elutasítása akadályozhatja
          működésüket.
        </p>
        <h2>Használunk Flash cookie-kat vagy helyi megosztott objektumokat?</h2>
        <p>
          A weboldalak úgynevezett „Flash cookie-kat” (Local Shared Objects vagy
          „LSO-k”) is használhatnak többek között az Ön által igénybe vett
          szolgáltatásokról való információk gyűjtésére és tárolására,
          csalásmegelőzésre és egyéb weboldali műveletekre.
        </p>
        <p>
          Ha nem szeretné, hogy Flash cookie-k kerüljenek tárolásra
          számítógépén, a Flash Player beállításainak módosításával blokkolhatja
          ezeket a következő helyen:{" "}
          <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html">
            Website Storage Settings Panel
          </a>
          . A Flash cookie-k kezelését a{" "}
          <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html">
            Global Storage Settings Panel
          </a>
          -en is elvégezheti az ott található útmutatások szerint (például
          hogyan törölje a meglévő Flash cookie-kat, hogyan akadályozza meg új
          Flash cookie-k automatikus tárolását, és hogyan blokkolja azokat a
          cookie-kat, amelyeket nem az Ön által meglátogatott oldal üzemeltetője
          küld).
        </p>
        <p>
          Kérjük, vegye figyelembe, hogy a Flash Player korlátozó beállításai
          csökkenthetik vagy akadályozhatják egyes Flash alkalmazások
          funkcionalitását, beleértve azokat is, amelyeket szolgáltatásainkkal
          vagy online tartalmunkkal összefüggésben használunk.
        </p>
        <h2>Használunk célzott hirdetéseket?</h2>
        <p>
          Harmadik felek cookie-kat helyezhetnek el számítógépén vagy
          mobileszközén, hogy weboldalunkon keresztül hirdetéseket jelenítsenek
          meg Önnek. Ezek a cégek felhasználhatják az Ön ezen és más
          weboldalakon tett látogatásairól szerzett információkat, hogy releváns
          hirdetéseket biztosítsanak termékekről és szolgáltatásokról, amelyek
          iránt érdeklődhet. Technológiákat is használhatnak a hirdetések
          hatékonyságának mérésére. Ezt cookie-k vagy webjelzők használatával
          valósítják meg, hogy információkat gyűjtsenek az Ön ezen és más
          oldalakon tett látogatásairól. Az így gyűjtött információk nem teszik
          lehetővé számunkra vagy számukra az Ön nevének, elérhetőségeinek vagy
          más közvetlenül azonosító adatainak megállapítását, hacsak Ön önként
          nem adja meg ezeket az információkat.
        </p>
        <h2>Milyen gyakran frissítjük ezt a Cookie szabályzatot?</h2>
        <p>
          Ezt a Cookie szabályzatot időről időre frissíthetjük, hogy például
          tükrözze a cookie-használatunkban bekövetkezett változásokat vagy
          egyéb működési, jogi vagy szabályozási okok miatt. Ezért kérjük,
          rendszeresen tekintse át ezt a Cookie szabályzatot, hogy naprakész
          legyen a cookie-k és kapcsolódó technológiák használatával
          kapcsolatban.
        </p>
        <p>
          A Cookie szabályzat tetején található dátum jelzi, mikor frissítettük
          utoljára.
        </p>
        <h2>Hol kaphatok további információkat?</h2>
        <p>
          Ha bármilyen kérdése van a cookie-k vagy egyéb technológiák
          használatáról, kérjük, írjon nekünk e-mailben a(z) {email} címre vagy
          postai úton az alábbi címre:
        </p>
        <p>
          <strong>{company}</strong>
        </p>
        <p>
          {country}, {province} {postalCode}, {city}, {address}
        </p>
      </div>
    </>
  );
};
